export default __webpack_public_path__ + "static/white-design-element-automation-a2014250512a56701f8e08ebfcc12f1f.png";